import React from 'react';
import ReactDOM from 'react-dom/client';
// pour gitHub Pages le HashRouter est nécéssaire , BrowserRouter uniquement en local. 
import { HashRouter as Router } from 'react-router-dom'; 
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <Router>
        <App />
      </Router>
);